import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ENVIRONMENT, Environment, HealthCheck } from '@netfoundry-ui/shared/model';
import { result, toLower } from 'lodash';
import { catchError, delay } from 'rxjs/operators';
import { throwError as observableThrowError } from 'rxjs/internal/observable/throwError';
import {
    GetOption,
    HateoasResourceOperation,
    HttpMethod,
    PagedGetOption,
    PagedResourceCollection,
} from '@lagoshny/ngx-hateoas-client';
import { take, tap } from 'rxjs/operators';
import { HTTP_CLIENT, TokenService } from './token.service';
import { LoggerService } from './logger.service';


@Injectable({ providedIn: 'root' })
export class HealthCheckService extends HateoasResourceOperation<HealthCheck> {
    apiUrl;
    appsUrl;
    networkPricing = 199.0;
    regionPricing = [{ region: null, price: 0.2, rate: 'GB' }];
    lastPageCount = 0;
    lastTotalCount = 0;
    static defaultHttpAccept = {
        headers: { accept: 'application/hal+json' },
        pageParams: {
            page: 0,
            size: 2000,
        },
    };

    constructor(
        private logger: LoggerService,
        private tokenService: TokenService,
        @Inject(HTTP_CLIENT) private http: HttpClient,
        @Inject(ENVIRONMENT) private environment: Environment
    ) {
        super(HealthCheck);
        this.apiUrl = this.environment.frontdoorURL;

    }


    public findHealthChecks(id: string, isV2: boolean, options?: PagedGetOption): Promise<HealthCheck[]> {
          const headers = new HttpHeaders().set('Accept', 'application/hal+json');
          const version = isV2 ? '/v2' : '';
        
          let params = new HttpParams().set('sort', 'createdAt,DESC');
        if(options) {
    if (options.pageParams) {
      Object.keys(options.pageParams).forEach(key => {
        const value = options.pageParams[key]; // <-- Corrected
        if (value !== undefined && value !== null) {
          params = params.append(key, String(value));
        }
      });
    }

   // Handle the nested params object
    if (options.params) {
      Object.keys(options.params).forEach(key => {
        const value = options.params[key]; // <-- Corrected
        if (value !== undefined && value !== null) {
          params = params.append(key, String(value));
        }
      });
    
  }
}
        return this.http
                .get<any>(`${this.apiUrl}${version}/${id}/health-checks`, {
                    headers,
                    params,
                    })
            .pipe(
                tap((val) => {
                    this.lastPageCount = val.page.totalPages;
                    this.lastTotalCount = val.page.totalElements;
                })
            )
            .toPromise()
    }

    executeHealthCheck(frontdoorId: string, id: string, isV2: boolean) {
        const version = isV2 ? '/v2' : '';
        const fullpath = `${this.apiUrl}${version}/${frontdoorId}/health-checks/${id}/execute`
        return this.http
            .get(fullpath, {
    headers: { Accept: 'application/hal+json' }
  })
    }

    public getHealthChecks(id, isV2: boolean) {
        const version = isV2 ? '/v2' : '';
        const fullpath = `${this.apiUrl}${version}/${id}/health-checks`
        return this.http
            .get(fullpath, {
    headers: { Accept: 'application/hal+json' }})
    }

    public getSingleHealthCheck(id, healthCheckId, isV2: boolean) {
        const version = isV2 ? '/v2' : '';
        const fullpath = `${this.apiUrl}${version}/${id}/health-checks/${healthCheckId}`
        return this.http
            .get(fullpath, {
    headers: { Accept: 'application/hal+json' }})
    }


    public create(model, id, isV2: boolean) {
        const version = isV2 ? '/v2' : '';
        const fullpath = `${this.apiUrl}${version}/${id}/health-checks`;
            return this.http
                .post(fullpath, model, )
    }

    public update(model, id, healthCheckId, isV2: boolean) {
        const version = isV2 ? '/v2' : '';
        const fullpath = `${this.apiUrl}${version}/${id}/health-checks/${healthCheckId}`;
            return this.http
            .patch(fullpath, model)
    }

        public delete(frontdoorId: string, id: string, isV2: boolean) {
            const version = isV2 ? '/v2' : '';
        const headers = this.setHeaders();
        const fullpath = `${this.apiUrl}${version}/${frontdoorId}/health-checks/${id}`;
            return this.http
                .delete(fullpath, {headers: headers})
    }

    public execute(model, id, isV2: boolean) {
        const version = isV2 ? '/v2' : '';
        const fullpath = `${this.apiUrl}${version}/${id}/health-checks/execute`;
            return this.http
                .post(fullpath, model, )
    }

    public getHealthChecksByShare(frontdoorId, shareToken, isV2: boolean) {
        const version = isV2 ? '/v2' : '';
            const fullpath = `${this.apiUrl}${version}/${frontdoorId}/health-checks?shareToken=${shareToken}`;
            return this.http
                .get(fullpath, {
    headers: { Accept: 'application/hal+json' }})
    }



    /**
     * @param path
     * @param data
     */
    public post(path: string, data) {
        const fullpath = `${this.apiUrl}${path}`;
        const body = data;

        return this.http.post(fullpath, JSON.stringify(body), { headers: this.setHeaders() });
    }

    /**
     * @param path
     * @param data
     */
    public put(path: string, data) {
        const fullpath = `${this.apiUrl}${path}`;
        const body = data;

        return this.http.put(fullpath, JSON.stringify(body), { headers: this.setHeaders() });
    }

    /**
     * Generic GETter
     */

    public get(path: string) {
        const fullpath = `${this.apiUrl}${path}`;

        return this.http.get(fullpath, { headers: this.setHeaders() });
    }

    /**
     * Return headers
     */
    private setHeaders(): HttpHeaders {
        const headers = new HttpHeaders();

                  return headers.append('Content-Type', 'application/json');
    }

        /**
     * Generic error handler for bad requests
     */
        protected handleError(scope: any, error: HttpErrorResponse) {
            if (error.error instanceof ErrorEvent) {
                // A client-side or network error occurred. Handle it accordingly.
                scope.logger.error('Feature Service error occurred:', error.error);
            } else {
                // The backend returned an unsuccessful response code.
                // The response body may contain clues as to what went wrong,
                scope.logger.error(`Feature Backend returned code ${error.status}`, error.error);
            }
            scope.lastErrorSource.next(error);
            return observableThrowError(error);
        }
}
